import { IdCard, HeartPulse, GraduationCap, Car, Briefcase, House, Lightbulb, Users, Scale, Landmark, HardHat, LayoutGrid } from "lucide-react";

export const SECTOR_STYLE = {
  S01: { icon: IdCard, color: "#8A1538", bg: "#FBEBF0", slug: "identity" },
  S02: { icon: HeartPulse, color: "#0E8A73", bg: "#E6F6F3", slug: "health" },
  S03: { icon: GraduationCap, color: "#2B569A", bg: "#EBF1FA", slug: "education" },
  S04: { icon: Car, color: "#C25A1C", bg: "#FDF0E7", slug: "transport" },
  S05: { icon: Briefcase, color: "#6B3884", bg: "#F4ECF8", slug: "business" },
  S06: { icon: House, color: "#4A6B22", bg: "#EEF4E8", slug: "housing" },
  S07: { icon: Lightbulb, color: "#00727C", bg: "#E0F7FA", slug: "utilities" },
  S08: { icon: Users, color: "#C2185B", bg: "#FCE4EC", slug: "social" },
  S09: { icon: Scale, color: "#455A64", bg: "#ECEFF1", slug: "justice" },
  S10: { icon: Landmark, color: "#C2410C", bg: "#FBE9E7", slug: "tourism" },
  S11: { icon: HardHat, color: "#5D4037", bg: "#EFEBE9", slug: "employment" },
};

export const sectorStyle = (id) => SECTOR_STYLE[id] || { icon: LayoutGrid, color: "#546E7A", bg: "#ECEFF1", slug: "other" };
